import axios from 'utils/requestHelper';

const fetchAll = (params) => axios.get('v1/clients/makers', { params });

const MakerAPI = {
  fetchAll,
};

export default MakerAPI;
